<template> 
	<section class="blockElement fix-mt">
		
	
		<div class="customFlex-wrapper" v-if="$route.path == '/step1' || $route.path == '/step2' || $route.path == '/step3'">
			<div class="w-100 ">
		        <div class="globalHeader w-100">
		            <header class="text-right d-flex align-items-center justify-content-between">
		                <div class="d-flex">
		                    <div class="Steplogo ">
		                        <router-link to="/dashboard" class="green">
		                            <img class="d-none d-xl-block" src="/static/fxView/images/logo-black.svg" alt="fxView">
		                            <img class="d-xl-none" src="/static/fxView/images/fxview_logo_white.svg" alt="fxView">
		                        </router-link>
		                    </div>
		                </div>
		                <div class="backSection">
		                    <router-link to="/dashboard" class="back"><feather type="home" ></feather> </router-link>
		                    <router-link to="/step1" class="back" v-if="$route.name == 'fxView.step_four' && parseInt(get_user.step) != 3" ><feather type="chevron-left"></feather> </router-link>
		                    <router-link to="/step2" class="back" v-else-if="$route.name == 'fxView.step_five' && parseInt(get_user.step) != 3" ><feather type="chevron-left" ></feather> </router-link>
		                </div>
		            </header>
		        </div>
		        <div class="d-flex justify-content-center align-items-center stepListing w-100" v-if="parseInt(get_user.step) != 3">
		            <ul class="d-flex justify-content-between">
		                <li class="nav-item d-flex align-items-center ">  
		                    <router-link to="/step1"  :class="($route.name == 'fxView.step_one')?'active':''">
		                        <figure><img src="../../../static/fxView/images/personal-information.svg" alt="fxView"></figure>
		                        <!-- <h3>Step 1</h3> -->
		                        <h4>{{$t('steps_heading1')}}</h4>
		                    </router-link>
		                    <span><feather type="chevron-right" ></feather></span>
		                </li>
		                <li  class="nav-item d-flex align-items-center"> 
		                    <router-link to="/step2" :class="($route.name == 'fxView.step_four')?'active':''">
		                        <figure><img src="../../../static/fxView/images/declaration.svg" alt="fxView"></figure>
		                        <!-- <h3>Step 2</h3> -->
		                        <h4>{{$t('steps_heading2')}}</h4>
		                    </router-link >
		                   <span><feather type="chevron-right" ></feather></span>
		                </li>
		                <li class="nav-item last d-flex align-items-center" >                       
		                    <router-link class="mr-0" to="/step3" :class="($route.name == 'fxView.step_five')?'active':''">
		                        <figure><img src="../../../static/fxView/images/cloud-computing.svg" alt="fxView"></figure>
		                        <!-- <h3>Step 3</h3> -->
		                        <h4>{{$t('steps_heading3')}}</h4>
		                    </router-link> 

		                </li>
		            </ul>
		        </div>
		        <router-view />
    		</div>
		</div>

		<div class="customFlex-wrapper":class="[{'activeMenu':mobmenu}]" v-else>
			<app-left-navbar :classMobileResponsive="classMobileResponsive" ></app-left-navbar>
			<div class=" rightArea dashboard vh_100 whiteBG scrollbar" >	
				<app-header :show_tab="show_header_tab" ></app-header>
				<div class="scrollbar  mainContent">
					<div class="mainContentOuter container" :class="($route.path == '/view')?'viewContainer':''" id="mainContentOuter">
						<router-view />
					</div>
				</div>
			</div>
		</div>

	</section> 
</template> 

<script>
	import * as types from '../../types'
	import { mapActions } from 'vuex'
	import Header from './shared/header'
	import leftNavbar from './shared/left_navbar'
	import { fxViewMixins } from '@/plugins/fxView'
	import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	import i18n from '@/plugins/lang/i18n';
	import { ProviderCacheMixins } from '@/plugins/vue-provider-cache/mixin'
	import moment from 'moment'
	export default {
		name: 'FXVIEW',
		mixins: [fxViewMixins,ProviderCacheMixins],
		data () { 
			return {
				response_msg : '',
                msg_type : '',
				show_header_tab : '',
				classMobileResponsive : false,
				pageLoader : false,
				demoAcountDeposit : false,
				sessionexpired : false,
				
				submitted : false,
				mobmenu : false,
				otp : '',
			}
		},
		components: {
			appHeader: Header,
			appLeftNavbar: leftNavbar
		},
		methods:{
			...mapActions({
				_runUserLogout: types.RUN_USER_LOGOUT,
				_runVerifyLeadOtp: types.RUN_VERIFY_LEAD_OTP,
				_runUserSignUp: types.RUN_USER_SIGNUP,
				_runRefreshData: types.RUN_STATE_LOAD,
			}),
			resend(){
                /*const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let hashedstr = mykey.update(this.password, 'utf8', 'hex')
                hashedstr += mykey.final('hex');*/
                let input_json={
					'globalParams' :{
						//"email": this.email,
						//"mobile": this.numberWithCountry,
						//"password" : hashedstr,
                        //"captchaToken":this.captchaToken,
                        //"IBREFERLINK":this.IBREFERLINK
					},
					'localParams' :{ "parameter" : this , 'page' : 'resend'}
				}
				this._runUserSignUp(input_json)
            },
			verify_lead(){
                /*const _that = this
                _that.submitted = true;

                const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let hashedstr = mykey.update(_that.password, 'utf8', 'hex')
                hashedstr += mykey.final('hex');*/

                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                //"email": _that.email,
                                //"mobile": _that.numberWithCountry,
                                //"password" : hashedstr,
                                "OTP": _that.otp,
                                //"ID": _that.insertId,
                                //"IBREFERLINK":_that.IBREFERLINK
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runVerifyLeadOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
			logout(){
				const _that = this
				let input_json={
					'globalParams' :{},
					'localParams' :{
						"parameter" : _that
					}
				}
				_that._runUserLogout(input_json)
			},
			changeLocale(locale) {
                i18n.locale = locale;    
            },
             dateDDMMFormat(dateVal){
	            return moment(dateVal).format("DD-MM-YYYY")
	        },
	        dateDDMMYYFormat(dateVal){
	            return moment(dateVal).format("DD MMM, YYYY")
	        }
			
		},
		mounted: function () {

		  	const _that = this
			window.addEventListener('storage', (e) => {
				//console.log("e", e)
			  	if(localStorage.getItem('unauthFlag') && localStorage.getItem('unauthFlag') == "true"){
					_that.sessionexpired = true
					_that.logout()
				}else{
					_that.sessionexpired = false
				}    
			});
		},
		created(){
			
			const _that = this
			
			if(localStorage.getItem('unauthFlag') && localStorage.getItem('unauthFlag') == "true"){
				_that.sessionexpired = true
				_that.logout()
			}else{
				_that.sessionexpired = false
			}
			this._runRefreshData({'globalParams' :{},'localParams' :{ "parameter" : this}})
			this._runApiDashboardData({'globalParams' :{},'localParams' :{ "parameter" : this}}) 

			// this._runGetUserProfile({'globalParams' :{},'localParams' :{ "parameter" : this , 'loaderFuncRun' : 1}})

			this._runGetCountriesList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
			this._runGetTicketReasonList({ 'globalParams' :{ },'localParams' :{"parameter" : this }})
			
			if(localStorage.getItem('lang') && this.get_user.lang != localStorage.getItem('lang')){
				// this._runLanguageApi({ 'globalParams' :{ 'lang' : localStorage.getItem('lang') },'localParams' :{"parameter" : this  ,'page' : 'left-bar'}})
			}
			
		},
		
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/index.vue